import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-[#1E3A8A] text-white py-12 sm:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-blue-100 hover:text-white mb-6 text-sm font-medium transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </Link>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-white" />
            </div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-300">Legal</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black" style={{ fontFamily: "Outfit" }}>
            {title}
          </h1>
          <p className="text-sm text-blue-100/80 mt-2">
            Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}
          </p>
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="bg-white rounded-3xl p-6 sm:p-10 lg:p-12 shadow-sm border border-slate-100 prose prose-slate max-w-none">
          {children}
        </article>
      </main>
    </div>
  );
}
